import type { ActionType } from '@/domains/academicRisk/academicRiskAction.entity';
import type { AcademicRiskActionRepository } from '@/domains/academicRisk/academicRiskAction.repository';

/**
 * Use Case para obtener tipos de acción académica
 *
 * Responsabilidades:
 * - Obtener tipos de acción desde el repositorio
 * - Actuar como intermediario entre dominio e infraestructura
 */
export class GetActionTypesUseCase {
  private repository: AcademicRiskActionRepository;

  /**
   * Inicializa el UseCase con el repositorio necesario
   * @param repository - Repositorio que implementa AcademicRiskRepository
   */
  constructor(repository: AcademicRiskActionRepository) {
    this.repository = repository;
  }

  /**
   * Ejecuta la obtención de tipos de acción
   * @throws Error si falla la comunicación con el repositorio
   */
  async execute(): Promise<ActionType[]> {
    return await this.repository.getActionTypes();
  }
}
